import React from "react";

import { createRoot } from "react-dom/client";
// import * as ReactDOM from 'react-dom';
import IPosModal from "./";
import Guid from "guid";

const confirm = (config) => {
  const div = document.createElement("div");
  div.id = Guid.create().value;
  document.body.appendChild(div);

  const root = createRoot(div);

  let currentConfig = { ...config, destroyPortal: destroy, visible: true };

  // function close(...args) {
  //   destroy(...args);
  // }

  function update(newConfig) {
    currentConfig = {
      ...currentConfig,
      ...newConfig,
    };
    render(currentConfig);
  }

  function destroy(...args) {
    // const unmountResult = ReactDOM.unmountComponentAtNode(div);
    const unmountResult = root.unmount(div);
    if (unmountResult && div.parentNode) {
      div.parentNode.removeChild(div);
    }
    // const triggerCancel = args.some(param => param && param.triggerCancel);
    // if (config.onCancel && triggerCancel) {
    //   config.onCancel(...args);
    // }
    // for (let i = 0; i < destroyFns.length; i++) {
    //   const fn = destroyFns[i];
    //   if (fn === close) {
    //     destroyFns.splice(i, 1);
    //     break;
    //   }
    // }
  }

  function render(props) {
    root.render(<IPosModal {...props} />);

    // ReactDOM.render(<IPosModal { ...props } />, div);
  }

  render(currentConfig);

  return {
    // destroy: close,
    destroy: destroy,
    update,
  };
};

export default confirm;
